<template>
    <div>
      
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-card class="box">
                <v-toolbar class="toolbar" flat dense>

                    <v-toolbar-title>View Document</v-toolbar-title>
                </v-toolbar>
            </v-card>
            <v-row fluid justify="center">
                <v-radio-group v-model="search_by_text_folder" row>
                    <v-radio color="brand"  label="Search By Text" value="search_text"></v-radio>
                    <v-radio color="brand"  label="Search By Folder" value="search_folder"></v-radio>
                </v-radio-group>

            </v-row>

            <!-- search_text-->
            <template v-if="search_by_text_folder === 'search_text'">
                <v-row fluid justify="center">
                    <v-radio-group v-model="search_by_type" row>
                        <v-radio color="brand" label="Name" value="name"></v-radio>
                        <v-radio color="brand" label="Validity Date" value="validity_date"></v-radio>
                        <v-radio color="brand" label="Upload Date" value="upload_date"></v-radio>
                        <v-radio color="brand" label="Issue Date" value="issue_date"></v-radio>
                        <v-radio color="brand" label="Keywords" value="keywords"></v-radio>
                        <v-radio color="brand" label="Document Category" value="document_category"></v-radio>
                        <v-radio color="brand" label="Document Level" value="document_level"></v-radio>
                    </v-radio-group>
                </v-row> 
                <!-- Search By Name -->
                <template v-if="search_by_type === 'name'">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="3" md="3"></v-col>
                        <v-col cols="12" sm="5" md="5">
                            <v-text-field v-model="document_name" color="#0F2027" rounded dense label="Name"
                                placeholder="Please Enter Name" outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-btn class="button" color="info" @click="searchByName">Search</v-btn>
                        </v-col>
                    </v-row>
                </template>

                <!-- Search By Date -->
                <template
                    v-if="search_by_type === 'validity_date' || search_by_type === 'upload_date' || search_by_type === 'issue_date'">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="2"></v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field outlined dense type="date" v-model="fromdate" label="From Date"
                                hint="From Date"></v-text-field>

                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field outlined dense type="date" v-model="todate" label="To Date"
                                hint="To Date"></v-text-field>

                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-btn class="button" color="info" @click="searchByDate">Search</v-btn>
                        </v-col>
                    </v-row>
                </template>

                <!-- Search By Keywords -->
                <template v-if="search_by_type === 'keywords'">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="1" md="1"></v-col>
                        <v-col cols="12" sm="5" md="5">
                            <v-textarea rounded name="input-7-4" outlined v-model="document_keywords"
                                label="Enter Keywords"></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="1" md="1" class="d-flex align-center justify-center">
                            <v-btn class="button" color="info" @click="searchByKeywords">Search</v-btn>
                        </v-col>
                    </v-row>
                </template>
                <!-- Search By Document Category -->
                <template v-if="search_by_type === 'document_category'">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="3" md="3"></v-col>
                        <v-col cols="12" sm="5" md="5">
                            <v-autocomplete color="#0F2027" dense rounded required v-model="document_category"
                                return-object :items="document_category_list" item-text="category_name"
                                label="Select Document Category" outlined persistent-hint
                                hint="Please Select Document Category" />
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-btn class="button" color="info" @click="searchBycategory">Search</v-btn>
                        </v-col>
                    </v-row>
                </template>
                <!-- Search By Document level -->
                <template v-if="search_by_type === 'document_level'">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="3" md="3"></v-col>
                        <v-col cols="12" sm="5" md="5">
                            <v-autocomplete color="#0F2027" dense rounded required v-model="document_level_for_search"
                                :items="document_level_list" item-value="id" item-text="name" label="Document Level"
                                outlined persistent-hint hint="Document Level" />
                        </v-col>
                        <v-col cols="12" sm="3" md="3">
                            <v-btn class="button" color="info" @click="searchBylevel">Search</v-btn>
                        </v-col>
                    </v-row>
                </template>
                <!-- Data Table to Display Documents -->
                <v-card v-if="documents_list_for_serch.length > 0">
                    <v-radio-group v-model="isActiveFilter" row class="justify-center">
                        <v-radio label=" Un-Archived" :value="false" style="font-weight: bold;"></v-radio>
                        <v-radio label="Archived" :value="true" style="font-weight: bold;"></v-radio>

                    </v-radio-group>
                    <v-data-table :headers="headers1" class="elevation-1 mytable" dense
                        :items="filteredDocuments_for_fetch">
                        <template v-slot:item.view="{ item }">
                            <span v-if="item.access_type.includes('View')">
                                <v-btn color="success" icon dark @click="getDetails(item)" title="View">
                                    <v-icon>mdi-book-open</v-icon>
                                </v-btn>
                            </span>
                            <span v-else>--</span>
                        </template>
                        <template v-slot:item.edit="{ item }">
                            <span v-if="item.access_type.includes('Edit')">
                                <v-avatar size="35">
                                    <v-icon class="mr-4 v-icon-size" @click="editDocument(item)">
                                        mdi-pencil
                                    </v-icon>
                                </v-avatar>
                            </span>
                            <span v-else>--</span>
                        </template>
                    </v-data-table>
                </v-card>

                <!-- Data Table to Display Documents -->

            </template>
            <!-- search_text-->
            <template v-if="search_by_text_folder === 'search_folder'">
                <div v-if="document_category_list.length !== 0 && documents_list.length !== 0">
                    <!-- Categories -->
                    <v-card v-if="!selectedCategory && !selectedSubCategory">
                        <v-card-text>
                            <v-row>

                                <v-col v-for="category in document_category_list" :key="category.category_id" cols="12"
                                    md="4">
                                    <v-card @click="toggleCategory(category)">
                                        <v-card-title>
                                            <v-avatar>
                                                <v-icon color="#FFD700">mdi-folder</v-icon>
                                            </v-avatar>
                                            {{ category.category_name }}
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <!-- Subcategories -->
                    <v-card v-if="selectedCategory && selectedCategory.div_list.length && !selectedSubCategory">
                        <v-card-title>
                            <v-btn color="indigo darken-1" icon text @click="closeCategory">
                                <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>
                            {{ selectedCategory.category_name }}
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col v-for="subCategory in filteredSubCategories" :key="subCategory.subcat_id"
                                    cols="12" md="4">
                                    <v-card @click="toggleSubCategory(subCategory)">
                                        <v-card-title>
                                            <v-avatar>
                                                <v-icon color="#FFD700">mdi-folder</v-icon>
                                            </v-avatar>
                                            {{ subCategory.subcat_name }}
                                        </v-card-title>
                                    </v-card>
                                </v-col>
                                <!-- <v-col v-for="subCategory in selectedCategory.div_list" :key="subCategory.subcat_id"
                                    cols="12" md="4">
                                    <v-card @click="toggleSubCategory(subCategory)">
                                        <v-card-title>
                                            <v-avatar>
                                                <v-icon color="#FFD700">mdi-folder</v-icon>
                                            </v-avatar>
                                            {{ subCategory.subcat_name }}
                                        </v-card-title>
                                    </v-card>
                                </v-col> -->
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <!-- Documents Table -->
                    <v-card v-if="tableOpen || (selectedCategory && !selectedCategory.div_list.length)">
                        <v-card-title>
                            <v-btn icon @click="closeSubCategory">
                                <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>
                            {{ selectedSubCategory ? selectedSubCategory.subcat_name : selectedCategory.category_name }}



                        </v-card-title>
                        <v-card-text>
                            <v-radio-group v-model="isActiveFilter_for_all_data" row class="justify-center">
                                <v-radio label=" Un-Archived" :value="false" style="font-weight: bold;"></v-radio>
                                <v-radio label="Archived" :value="true" style="font-weight: bold;"></v-radio>

                            </v-radio-group>
                            <v-data-table :headers="headers" class="elevation-1 mytable" dense
                                :items="filteredDocuments">
                                <template v-slot:item.view="{ item }">
                                    <span v-if="item.access_type.includes('View')">
                                        <v-btn color="success" icon dark @click="getDetails(item)" title="View">
                                            <v-icon>mdi-book-open</v-icon>
                                        </v-btn>
                                    </span>
                                    <span v-else>--</span>
                                </template>
                                <template v-slot:item.edit="{ item }">
                                    <span v-if="item.access_type.includes('Edit')">
                                        <v-avatar size="35">
                                            <v-icon class="mr-4 v-icon-size"
                                                @click="editDocument(item)">mdi-pencil</v-icon>
                                        </v-avatar>
                                    </span>
                                    <span v-else>--</span>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </div>

            </template>
            <br>


        </v-card>









        <v-dialog v-model="view_dialog" max-width="1200px" persistent>
            <v-card>
                <br>

                <v-card-text>
                    <v-row>
                        <v-col style="font-weight: bold;" sm="12" md="4">Document Category : {{
                            view_Details.documentcategory
                            }}</v-col>

                        <v-col style="font-weight: bold;" sm="12" md="4">Document Sub Category : {{
                            view_Details.documentsubcategory
                            }}
                        </v-col>

                        <v-col style="font-weight: bold;" sm="12" md="4">Academic Year : {{
                            view_Details.ay
                            }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col style="font-weight: bold;" sm="12" md="4">Password : {{ view_Details.opening_password
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Keywords : {{ view_Details.keywords
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Owner : {{ view_Details.entryby
                            }}</v-col>
                    </v-row>
                    <v-row>

                        <v-col style="font-weight: bold;" sm="12" md="4">Assigned To : {{ view_Details.assignedto
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Vendor : {{ view_Details.vendor
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Document Level : {{
                            view_Details.documentlevel
                            }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col style="font-weight: bold;" sm="12" md="4">Reference Number : {{
                            view_Details.reference_number
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Assigned Person Email : {{
                            view_Details.assigned_person_email
                            }}</v-col>


                        <v-col style="font-weight: bold;" sm="12" md="4">Assigned Person Contact : {{
                            view_Details.assigned_person_contact
                            }}</v-col>

                    </v-row>
                    <v-row>
                        <v-col style="font-weight: bold;" sm="12" md="4">Target Person Name : {{
                            view_Details.target_person_name
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Document : <span
                                v-if="view_Details.attachment != null">

                                <a target="_blank" :href="awspath + view_Details.attachment">Attachment</a>
                            </span></v-col>


                        <v-col style="font-weight: bold;" sm="12" md="4"></v-col>

                    </v-row>

                    <!-- <v-row>
                        <v-col style="font-weight: bold;" sm="12" md="4">Document :
                            <span v-if="view_Details.attachment != null">
                                <a target="_blank" :href="awspath + view_Details.attachment">Attachment</a>
                            </span>
                            <span v-else>-</span></v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Reference Number : {{
                            view_Details.reference_number
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Academic Year : {{
                            view_Details.ay
                            }}</v-col>
                    </v-row> -->
                    <!-- <v-row>
                        <v-col style="font-weight: bold;" sm="12" md="4">Password : {{ view_Details.opening_password
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Keywords : {{ view_Details.keywords
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Owner : {{ view_Details.entryby
                            }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col style="font-weight: bold;" sm="12" md="4">Assigned To : {{ view_Details.assignedto
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Vendor : {{ view_Details.vendor
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="4">Document Level : {{
                            view_Details.documentlevel
                            }}</v-col>

                    </v-row>
                    <v-row justify="center">


                        <v-col style="font-weight: bold;" sm="12" md="5">Assigned Person Email : {{
                            view_Details.assigned_person_email
                            }}</v-col>
                        <v-col style="font-weight: bold;" sm="12" md="3"></v-col>

                        <v-col style="font-weight: bold;" sm="12" md="4">Assigned Person Contact : {{
                            view_Details.assigned_person_contact
                            }}</v-col>
                    </v-row> -->
                </v-card-text>
                <v-card-actions class="justify-center"><v-btn color="warning"
                        @click="view_dialog = false">Close</v-btn></v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="show_documents_edit_card" fullscreen transition="dialog-bottom-transition">
            <v-card class="box">
                <v-toolbar flat class="toolbar">
                    <v-toolbar-title> Edit Document
                    </v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn fab small color="white" outlined icon @click="show_documents_edit_card = false"><v-icon>
                            mdi-close
                        </v-icon></v-btn>
                </v-toolbar>
                <br>


                <v-row justify="center">
                    <v-col cols="12" sm="4">

                        <v-text-field rounded outlined dense type="text" label="Document Name"
                            v-model="edited_document_Item.doc_name" width="50"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" justify="center" align="center">
                        <v-text-field rounded outlined dense type="text" label="Document Reference Number"
                            v-model="edited_document_Item.reference_number"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="edited_document_Item.ay"
                            :items="ay_list" item-value="id" item-text="ay" label="Select AY" outlined persistent-hint
                            hint="Please Select AY" />
                    </v-col>

                </v-row>
                <v-row justify="center" class="pa-40">
                    <v-col cols="12" sm="4">
                        <v-text-field label="Validity From Date(inclusive)" rounded outlined dense type="date"
                            v-model="edited_document_Item.validity_fromdate"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field label="Validity To Date(Exclusive)" rounded outlined dense type="date"
                            v-model="edited_document_Item.validity_todate"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field label="Issue Date" rounded outlined dense type="date"
                            v-model="edited_document_Item.issue_date"></v-text-field>
                    </v-col>

                </v-row>
                <v-row justify="center" class="pa-40">

                    <v-col cols="12" sm="4" md="4">

                        <v-file-input prepend-icon="mdi-paperclip" label="Attachment" show-size flat rounded outlined
                            dense v-model="edited_document_Item.doc_file"></v-file-input>
                        <span v-if="edited_document_Item.attachment != null">
                            Previous File : <a target="_blank"
                                :href="awspath + edited_document_Item.attachment">View</a>
                        </span>


                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-text-field rounded outlined dense :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
                            label="File Opening Password(If Any)" v-model="edited_document_Item.opening_password"
                            @click:append="() => (value = !value)" :type="value ? 'password' : 'text'"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field rounded outlined dense type="text" label="Keywords To Search File"
                            v-model="edited_document_Item.keywords"></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center" class="pa-40" v-if="this.documentcategory != 'Office Order'">
                    <v-col cols=" 12" sm="4">
                        <v-autocomplete color="#0F2027" dense rounded required
                            v-model="edited_document_Item.assigned_to" :items="instructor_list" item-value="id"
                            item-text="name" return-object label="Assigned To" outlined persistent-hint
                            hint="Please Assigned To" @change="setvalues(edited_document_Item.assigned_to)" />
                    </v-col>

                    <v-col cols="12" sm="4">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="edited_document_Item.vendor"
                            :items="vendor_list" item-value="id" item-text="company_name" label="Select Vendor" outlined
                            persistent-hint hint="Please Select Vendor" />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field rounded outlined dense type="text" label="Target Person"
                            v-model="edited_document_Item.target_person_name"></v-text-field>
                    </v-col>

                </v-row>
                <v-row class="pa-40">
                    <v-col cols="12" sm="4">
                        <v-autocomplete color="#0F2027" dense rounded required
                            v-model="edited_document_Item.document_level" :items="document_level_list" item-value="id"
                            item-text="name" label="Document Level" outlined persistent-hint hint="Document Level" />
                    </v-col>
                    <v-col cols="12" sm="4" v-if="this.documentcategory
                        === 'Office Order'">
                        <v-autocomplete color="#0F2027" dense rounded required v-model="edited_document_Item.instructor"
                            :items="instructor_list" item-text="name" item-value="id" return-object
                            label="Please Select Instructor" outlined persistent-hint hint="Please Select Instructor" />
                    </v-col>
                    <v-col cols="12" sm="4" v-if="edited_document_Item.assigned_to && this.documentcategory
                        != 'Office Order'">
                        <v-text-field rounded outlined dense type="text" label="Assigned Person Email"
                            v-model="edited_document_Item.assigned_person_email"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" v-if="edited_document_Item.assigned_to && this.documentcategory
                        != 'Office Order'">
                        <v-text-field rounded outlined dense type="text" label="Assigned Person Contact"
                            v-model="edited_document_Item.assigned_person_contact"></v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" sm="4">
                        <v-textarea outlined name="input-7-4" v-model="edited_document_Item.description"
                            label="Enter Description"></v-textarea>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-btn class="button" :loading="loader" @click="EditDocument" dense>Edit</v-btn>
                </v-row>
                <br>
            </v-card>



        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        snackbar_msg: "",
        extraBreadcrumbItems: [

        ],
        breadcrumbClass: "breadcrumb-style1",
        color: "",
        snackbar: false,
        overlay: false,
        awspath: null,
        ay_list: [],
        selectedCategory: null,
        selectedSubCategory: null,
        tableOpen: false,
        isActiveFilter: false,
        isActiveFilter_for_all_data: false,
        documentcategory: "",
        instructor_list: [],
        documents_list: [],
        documents_list_for_serch: [],
        vendor_list: [],
        document_level_list: [],
        document_category_list: [],


        document_level_for_search: "",
        search_by_type: null,
        search_by_text_folder: null,
        document_name: "",
        document_keywords: "",
        document_category: "",
        view_Details: "",
        value: String,
        view_dialog: false,
        loader: false,
        show_documents_edit_card: false,
        edited_document_Item: {
            id: "",
            doc_name: "",
            reference_number: "",
            ay: "",
            instructor: "",
            document_category: "",
            document_sub_category: "",
            validity_fromdate: "",
            validity_todate: "",
            assigned_to: "",
            attachment: "",
            opening_password: "",
            issue_date: "",
            keywords: "",
            vendor: "",
            document_level: "",
            target_person_name: "",
            assigned_person_email: "",
            assigned_person_contact: "",
            description: "",
        },
        fromdate: new Date(new Date().getFullYear(), new Date().getMonth() - 0, 2).toISOString().substr(0, 10),
        todate: new Date().toISOString().slice(0, 10),


        headers: [
            // { text: "Srno", value: "srno" },
            { text: "Name", value: "name" },
            { text: "View", value: "view" },
            { text: "Edit", value: "edit" },
        ],
        headers1: [
            // { text: "Srno", value: "srno" },
            { text: "Name", value: "name" },
            { text: "View", value: "view" },
            { text: "Edit", value: "edit" },
        ],
    }),
    mounted() {
        this.awspath = localStorage.getItem("awspath");
        this.onLoad();
    },
    computed: {
        filteredSubCategories() {
            return this.selectedCategory.div_list.filter(subCategory => {
                // Check if there are any documents associated with the subcategory
                const subCategoryDocuments = this.documents_list.filter(
                    document => document.documentsubcategory_id === subCategory.subcat_id
                );
                return subCategoryDocuments.length > 0; // Only include non-empty subcategories
            });
        },
        filteredDocuments() {
            if (!this.selectedCategory) return [];
            const categoryId = this.selectedCategory.category_id;
            const subCategoryId = this.selectedSubCategory ? this.selectedSubCategory.subcat_id : null;
            const isActiveFilter = this.isActiveFilter_for_all_data; // false for un-archived, true for archived
            return this.documents_list.filter(document => {
                return document.documentcategory_id === categoryId &&
                    (!subCategoryId || document.documentsubcategory_id === subCategoryId) &&
                    document.isactive === !isActiveFilter; // Inverted: false means un-archived, true means archived
            });
        },
        filteredDocuments_for_fetch() {
            // Fetch documents based on the current filter (archived/un-archived)
            return this.documents_list_for_serch.filter(doc => doc.isactive === !this.isActiveFilter);
        },

    },
    methods: {
        toggleCategory(category) {
            this.selectedCategory = category;
            this.selectedSubCategory = null;
            this.tableOpen = !category.div_list.length;
        },
        closeCategory() {
            this.selectedCategory = null;
            this.selectedSubCategory = null;
            this.tableOpen = false;
        },
        toggleSubCategory(subCategory) {
            this.selectedSubCategory = subCategory;
            this.tableOpen = true;
        },
        closeSubCategory() {
            if (this.selectedSubCategory) {
                this.selectedSubCategory = null;
                this.tableOpen = false;
            } else {
                this.closeCategory();
            }
        },
        onLoad() {
            this.overlay = true;
            axios.post("/AMC/getAllDocumentsAccessForInstructor")
                .then(res => {
                    this.overlay = false;
                    if (res.data.flag == "YES") {
                        this.ay_list = res.data.ay_list
                        this.instructor_list = res.data.instructor_list
                        this.vendor_list = res.data.vendor_list
                        this.documents_list = res.data.documents_list;
                        this.document_level_list = res.data.document_level_list;

                        this.document_category_list = res.data.data;

                    } else {

                        this.showSnackbar("red", res.data.Message);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch(error => {
                    this.overlay = false; // Hide overlay if there's an error
                    console.error(error);
                });
        },
        setvalues(inst) {
            this.edited_document_Item.assigned_person_email = inst.inst_email
            this.edited_document_Item.assigned_person_contact = inst.inst_contact
        },
        async EditDocument() {
            const toupdatedDocumentlog = this.edited_document_Item;
            let assignedToId = this.edited_document_Item.assigned_to ? this.edited_document_Item.assigned_to.id : this.edited_document_Item.assigned_to; // Handle assigned_to correctly
            let instructorId = this.edited_document_Item.instructor ? this.edited_document_Item.instructor.id : this.edited_document_Item.instructor; // Handle assigned_to correctly

            let formData = new FormData();
            formData.append("id", this.edited_document_Item.id);
            formData.append("doc_file", this.edited_document_Item.doc_file);
            formData.append("description", this.edited_document_Item.description);
            formData.append("reference_number", this.edited_document_Item.reference_number);
            formData.append("doc_name", this.edited_document_Item.doc_name);
            formData.append("ay", this.edited_document_Item.ay);
            formData.append("vendor", this.edited_document_Item.vendor);
            formData.append("document_level", this.edited_document_Item.document_level);
            formData.append("issue_date", this.edited_document_Item.issue_date);
            formData.append("fromdate", this.edited_document_Item.validity_fromdate);
            formData.append("todate", this.edited_document_Item.validity_todate);
            formData.append("assigned_to", assignedToId);
            formData.append("assigned_person_email", this.edited_document_Item.assigned_person_email);
            formData.append("assigned_person_contact", this.edited_document_Item.assigned_person_contact);
            formData.append("opening_password", this.edited_document_Item.opening_password);
            formData.append("keywords", this.edited_document_Item.keywords);
            formData.append("target_person_name", this.edited_document_Item.target_person_name);
            formData.append("document_category", this.edited_document_Item.document_category);
            formData.append("document_sub_category", this.edited_document_Item.document_sub_category);
            formData.append("instructor", instructorId);
            this.overlay = true;
            this.loader = true;
            try {
                const res = await axios.post("/AMC/updateDocumentAccess", formData)
                if (res.data.status == "200") {
                    this.showSnackbar("green", "Update Successfully...");
                    this.show_documents_edit_card = false;
                    this.logAccessedit(toupdatedDocumentlog);
                    this.documents_list = [];
                    this.documents_list_for_serch = [];

                    this.onLoad();
                } else {
                    this.showSnackbar("red", res.data.snackbar);
                    sessionStorage.setItem("error-trace", res.data.error_trace);
                }
                this.overlay = false;
                this.loader = false;
            }
            catch (err) {
                this.onerror(err);
                this.overlay = false;
            }
            finally {
                this.overlay = false;
                this.loader = false;
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Unexpected error.";
            }
            this.showSnackbar("error", msg);
        },
        searchByName() {
            const formdata = {
                type: 'name',
                document_name: this.document_name,
            };
            this.performSearch(formdata);
        },
        searchByDate() {
            const formdata = {
                type: this.search_by_type,
                fromdate: this.fromdate,
                todate: this.todate,
            };
            this.performSearch(formdata);
        },
        searchByKeywords() {
            const formdata = {
                type: 'keywords',
                document_keywords: this.document_keywords,
            };
            this.performSearch(formdata);
        },
        searchBycategory() {
            const formdata = {
                type: 'document_category',
                document_category: this.document_category.category_id,
            };
            this.performSearch(formdata);
        },
        searchBylevel() {
            const formdata = {
                type: 'document_level',
                document_level: this.document_level_for_search,
            };
            this.performSearch(formdata);
        },
        performSearch(formdata) {
            this.documents_list_for_serch = [];
            this.selectedCategory = null;
            this.selectedSubCategory = null;
            this.tableOpen = false;
            this.overlay = true;
            axios
                .post('/AMC/viewDocumentAccess', formdata)
                .then((res) => {
                    if (res.data.flag === 'YES') {
                        this.ay_list = res.data.ay_list
                        this.instructor_list = res.data.instructor_list
                        this.vendor_list = res.data.vendor_list
                        this.document_level_list = res.data.document_level_list
                        this.documents_list_for_serch = res.data.document_list.map(doc => ({
                            ...doc,
                            validity_start_date: doc.validity_start_date || '',
                            validity_end_date: doc.validity_end_date || '',
                            upload_date: doc.upload_date || '',
                            issue_date: doc.issue_date || '',
                            keywords: doc.keywords || '',
                            access_type: doc.access_type || []
                        }));

                    } else {
                        this.showSnackbar('red', res.data.snackbar);
                        sessionStorage.setItem('error-trace', res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        editDocument(item) {
            console.log('Editing document:', item);
            this.edited_document_Item.id = item.id;
            this.edited_document_Item.doc_name = item.name;
            this.edited_document_Item.reference_number = item.reference_number;
            this.edited_document_Item.ay = item.academicyear;
            this.edited_document_Item.validity_fromdate = this.formatDate(item.validity_start_date);
            this.edited_document_Item.validity_todate = this.formatDate(item.validity_end_date);
            this.edited_document_Item.assigned_to = item.assignedto_id ? { id: item.assignedto_id, name: item.assignedto_name } : null; // Ensure assigned_to is correctly set
            this.edited_document_Item.attachment = item.attachment;
            this.edited_document_Item.opening_password = item.opening_password;
            this.edited_document_Item.issue_date = this.formatDate(item.issue_date);;
            this.edited_document_Item.keywords = item.keywords;
            this.edited_document_Item.vendor = item.vendor_id;
            this.edited_document_Item.document_level = item.documentlevel_id;
            this.edited_document_Item.target_person_name = item.target_person_name;
            this.edited_document_Item.assigned_person_email = item.assigned_person_email;
            this.edited_document_Item.assigned_person_contact = item.assigned_person_contact;
            this.edited_document_Item.description = item.description;
            this.documentcategory = item.documentcategory;
            this.edited_document_Item.document_sub_category = item.documentsubcategory_id;
            this.edited_document_Item.document_category = item.documentcategory_id;
            this.edited_document_Item.instructor = item.instructor_id ? { id: item.instructor_id, name: item.instructor } : null;
            this.show_documents_edit_card = true;
        },
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            let month = '' + (d.getMonth() + 1);
            let day = '' + d.getDate();
            const year = d.getFullYear();
            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;
            return [year, month, day].join('-');
        },
        getDetails(item) {

            this.view_Details = item;
            this.view_dialog = true;
            this.logAccessView(item);
        },
        logAccessView(item) {
            const data = {
                document_id: item.id,
                documentAccessControlMaster: 'View'
            };
            axios
                .post('/AMC/saveDocumentAccessLogsForReport', data)
                .then((res) => {
                    if (res.data.flag === 'YES') {
                        this.showSnackbar('green', res.data.status.message);

                    } else {
                        this.showSnackbar('red', res.data.status.message);
                        sessionStorage.setItem('error-trace', res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.showSnackbar('red', 'An error occurred while saving document access log.');
                    console.error(error);
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        logAccessedit(item) {
            const data = {
                document_id: item.id,
                documentAccessControlMaster: 'Edit'
            };
            axios
                .post('/AMC/saveDocumentAccessLogsForReport', data)
                .then((res) => {
                    if (res.data.flag === 'YES') {
                        this.showSnackbar('green', res.data.status.message);
                    } else {
                        this.showSnackbar('red', res.data.status.message);
                        sessionStorage.setItem('error-trace', res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar('red', 'An error occurred while saving document access log.');
                    console.error(error);
                });
        },

    },
};
</script>

<style scoped>
.box1 {
    background-color: white !important;
    border: 2px solid #8360c3 !important;
    width: 45%;
    margin-left: 28%;
}

.header span {
    font-weight: 500;
    font-size: 13px;
}



.button {
    margin: 0 !important;
}
</style>
